import { render, staticRenderFns } from "./CanvasTouchTest.vue?vue&type=template&id=41052869"
import script from "./CanvasTouchTest.vue?vue&type=script&lang=js"
export * from "./CanvasTouchTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports